export const styles = {
  header: {
    margin: '50px 0 30px 0'
  }
}
